// extracted by css-extract-rspack-plugin
export default {"container":"_d5016611","label":"_96700ef0","linksContainer":"_907e9822","spacer":"_b07f9860"};